import React, { useState, useMemo, useEffect, useCallback } from 'react'
import ReactPlaceholder from 'react-placeholder/lib'
import Controllers from '../../Api/Controllers'
import { Input, FormCustom, Select, SwitchToggle } from '../../Components/Form/Form'
import Helpers from '../../Components/Helpers/Helpers'
import { toast } from 'react-toastify';
import Button from 'react-bootstrap/esm/Button'
import ProductList from '../Product/ProductList'
import ReactDataTableBootstrap from '../../Components/ReactDataTableBootstrap/ReactDataTableBootstrap'
import Card from 'react-bootstrap/esm/Card'
import Modal from 'react-bootstrap/esm/Modal'

const PalletStockForm = ({ data, onSubmit, disablebSubmit, loadSubmit, picking, history, historyFull }) => {
    const [row, setRow] = useState({
        p_id_pallet_stock: data.id_pallet_stock,
        p_name_pallet_stock: data.name_pallet_stock,
        p_id_branch_office: data.id_branch_office
    })

    const [ready, setReady] = useState(false)
    const [rowsProducts, setRowProducts] = useState([])
    const [isProcessing, setIsProccesing] = useState(true)
    const [isLoadingPicking, setIsLoadingPicking] = useState(true)
    const [dataUpdated, setDataUpdated] = useState({
        data: [],
        id_pallet_stock_history: ''
    })

    const [modalProducts, setModalProducts] = useState(false)

    const [rows, setRows] = useState([])

    const [listBranchOffice, setListBranchOffice] = useState([])
    const branchOffice = useMemo(() => {
        if (!row.p_id_branch_office) {
            return ''
        }

        let finded = listBranchOffice.find(t => parseInt(row.p_id_branch_office) === parseInt(t.id_branch_office))

        if (!finded) {
            return ''
        }
        return {
            label: finded.name_branch_office,
            value: finded.id_branch_office
        }
    }, [row.p_id_branch_office, listBranchOffice])

    const dataSubmit = useCallback(() => {
        return {
            ...row,
            p_products: rowsProducts,
        }
    }, [row])

    const handleGet = e => {
        let $this = e.currentTarget

        let buttonHTML = $this.innerHTML;
        $this.innerHTML = '<i class="fa fa-circle-notch fa-spin"></i>'
        let { idPalletStock, idPalletStockHistory } = $this.dataset

        setIsLoadingPicking(true)

        Controllers.pallet_stock.get_pallet_stock_products({ p_id_pallet_stock: idPalletStock, p_id_pallet_stock_history: idPalletStockHistory }).then(res => {
            setDataUpdated({
                data: res.data,
                id_pallet_stock_history: idPalletStockHistory
            })
            setIsLoadingPicking(false)
        }).catch(req => {
            Helpers.promise.catch({ req, toast })
        })
            .finally(() => $this.innerHTML = buttonHTML)
    }

    const dtRows = useMemo(() => <ReactDataTableBootstrap
        head={[
            [
                { name: 'id_pallet_stock_history', text: 'ID' },
                { name: 'created_at', text: 'Fecha' },
                { name: 'user_created', text: 'Usuario' },
                {
                    name: 'actions', text: <i className="fa fa-cog"></i>, align: 'center', render: u => {
                        return <div>
                            <Button variant="info" className="mr-1" size="xs" data-id-pallet-stock={u.id_pallet_stock} data-id-pallet-stock-history={u.id_pallet_stock_history} onClick={handleGet}>
                                <i className="fa fa-eye"></i>
                            </Button>
                        </div>
                    }
                },
            ],
        ]}
        rows={rows}
        isProcessing={isProcessing}
    />, [rows, isProcessing])

    useEffect(() => {
        let promises = [
            Controllers.pallet_stock.get_pallet_stock_products({
                p_id_pallet_stock: data.id_pallet_stock,
                p_id_pallet_stock_history: ''
            }),
            Controllers.worker.get_worker_all_branch_office_without_laboratory(),
        ]

        if (parseInt(history) === 1) {
            promises.push(Controllers.pallet_stock.get_pallet_stock_history({
                p_id_pallet_stock: data.id_pallet_stock,
            }))
        }

        if (parseInt(historyFull) === 1) {
            promises.push(Controllers.pallet_stock.get_pallet_stock_history_full({
                p_id_pallet_stock: data.id_pallet_stock,
            }))
        }

        Promise.all(promises).then(res => {
            setRowProducts(res[0].data)
            setListBranchOffice(res[1].data)
            if (parseInt(history) === 1) {
                setRows(res[2].data)
                setIsProccesing(false)
            }
            if (parseInt(historyFull) === 1) {
                setRows(res[2].data)
                setIsProccesing(false)
            }
            setReady(true)
        })
    }, [])

    const handleHideModalProducts = () => setModalProducts(false)

    const optionsMovement = [{ label: 'ENTRADA', value: 'ENTRADA' }, { label: 'SALIDA', value: 'SALIDA' }]

    return <ReactPlaceholder ready={ready} rows={7}>
        <FormCustom dataSubmit={dataSubmit()} onSubmit={({ data }) => {
            if (!row.p_id_branch_office) {
                Helpers.toast.construct({ response: 'warning', message: 'Por favor, seleccionar sucursal', toast })
                return false
            }

            if (parseInt(picking) === 1 && rowsProducts.length === 0) {
                Helpers.toast.construct({ response: 'warning', message: 'Por favor, seleccionar productos', toast })
                return false
            }

            if (parseInt(picking) === 1) {
                data.p_products = rowsProducts

                let hasError = false
                rowsProducts.forEach(p => {
                    if (!hasError && !p.movement) {
                        hasError = true
                    }
                })

                if (hasError) {
                    Helpers.toast.construct({ response: 'warning', message: 'Por favor, seleccionar movimientos', toast })
                    return false
                }
            }

            onSubmit({ data })
        }} disablebSubmit={disablebSubmit} loadSubmit={loadSubmit} viewSubmit={parseInt(history) !== 1 && parseInt(historyFull) !== 1}>
            <Input
                text="Nombre"
                placeholder="Nombre"
                classNameParent="col-12 mb-2"
                icon="far fa-comment-alt"
                required
                invalid="El campo es obligatorio."
                defaultValue={data.name_pallet_stock}
                onChange={e => setRow({ ...row, p_name_pallet_stock: e.currentTarget.value })}
                maxLength={255}
                disabled={parseInt(picking) === 1 || parseInt(history) === 1 || parseInt(historyFull) === 1}
            />
            <Select
                classNameParent="col-12 col-md-4mb-2"
                icon="far fa-building"
                text="Sucursal"
                options={listBranchOffice.map(t => {
                    return {
                        label: t.name_branch_office,
                        value: t.id_branch_office
                    }
                })}
                value={branchOffice}
                onChange={e => {
                    setRow({ ...row, p_id_branch_office: e.value })
                }}
                disabled={!isNaN(parseInt(row.p_id_pallet_stock))}
            />
            {parseInt(picking) === 1 || parseInt(history) === 1 ? <>
                <div className="col-12"><hr /></div>
                <div className="col-12">
                    {parseInt(picking) === 1 ? <Button variant="primary" size="sm" className="mb-2" onClick={_ => {
                        if (row.p_id_branch_office) {
                            setModalProducts(true)
                        }
                    }}>
                        <i className="fa fa-plus mr-2"></i>Agregar Productos
                    </Button> : ''}
                    {parseInt(history) === 1 ? <div className="mb-2 mt-4">
                        <strong>Stock Actual</strong>
                    </div> : ''}
                    <div className="table-responsive">
                        <table className="table table-sm table-hover table-striped">
                            <thead>
                                <tr>
                                    <th>Clave</th>
                                    <th>Nombre</th>
                                    <th style={{ width: 280 }}>Stock</th>
                                    {parseInt(picking) === 1 ? <>
                                        <th style={{ width: 280 }}>Movimiento</th>
                                        <th style={{ width: 280 }}>Cantidad</th>
                                    </> : ''}
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                {React.Children.toArray(rowsProducts.map((p, i) => {
                                    return <tr>
                                        <td>
                                            <div>{p.key_product}</div>
                                            {parseInt(p.exists_pallet_stock) === 1 ? <div className="text-danger">Existe ubicación para este producto</div> : ''}
                                        </td>
                                        <td>{p.name_product}</td>
                                        <td className="text-center">
                                            {parseInt(history) === 1 ? p.qty_real : <Input
                                                type="number"
                                                className="text-center"
                                                min="0"
                                                step="1"
                                                required
                                                value={p.qty_real}
                                                disabled
                                            />}
                                        </td>
                                        {parseInt(picking) === 1 ? <>
                                            <td className="text-center" style={rowsProducts.length === i + 1 ? {
                                                paddingBottom: 80
                                            } : {}}>
                                                <Select
                                                    options={optionsMovement}
                                                    onChange={e => setRowProducts(rowsProducts.map((p2, i2) => {
                                                        if (i === i2) {
                                                            p2.movement = e.value
                                                        }
                                                        return p2
                                                    }))}
                                                    value={optionsMovement.some(m => m.value === p.movement) ? optionsMovement.find(m => m.value === p.movement) : ''}
                                                    disabled={isNaN(parseInt(p.id_pallet_stock_det))}
                                                />
                                            </td>
                                            <td className="text-center">
                                                <Input
                                                    type="number"
                                                    className="text-center"
                                                    min="0"
                                                    {...(p.movement === 'SALIDA' ? {
                                                        max: p.qty_real
                                                    } : {})}
                                                    step="1"
                                                    required
                                                    value={p.qty_product}
                                                    onChange={e => setRowProducts(rowsProducts.map((p2, i2) => {
                                                        if (i === i2) {
                                                            p2.qty_product = e.currentTarget.value
                                                        }
                                                        return p2
                                                    }))}
                                                />
                                            </td>
                                        </> : ''}
                                        <td>
                                            {isNaN(parseInt(data.id_document)) && isNaN(parseInt(p.id_pallet_stock_det)) ? <Button size="xs" variant="danger" onClick={() => {
                                                setRowProducts(rowsProducts.filter((p2, i2) => i2 !== i))
                                            }}>
                                                <i className="fa fa-trash"></i>
                                            </Button> : ''}
                                        </td>
                                    </tr>
                                }))}
                            </tbody>
                        </table>
                    </div>
                </div>
            </> : ''}
        </FormCustom>
        <ProductList showModal={modalProducts} hideModal={handleHideModalProducts} nameSingle="Producto" namePlural="Productos" separator="el" showButtonNewProduct={false} added={rowsProducts} idBranchOffice={row.p_id_branch_office} addItem={({ idProduct, keyProduct, nameProduct, existsPalletStock }) => {
            let newDet = ({
                id_product: idProduct,
                key_product: keyProduct,
                name_product: nameProduct,
                qty_product: '',
                qty_real: 0,
                movement: 'ENTRADA',
                exists_pallet_stock: existsPalletStock
            })
            setRowProducts([...rowsProducts, newDet])
        }} />

        {parseInt(history) === 1 ? <>
            <div className="mt-4 mb-2 font-weight-bold"><span>Listado De Pickings</span></div>
            <ReactPlaceholder ready={ready} rows={15} showLoadingAnimation>
                {dtRows}
            </ReactPlaceholder>
            {isLoadingPicking || isNaN(parseInt(dataUpdated.id_pallet_stock_history)) ? '' : <>
                <div className="mt-4 mb-3">Detalle del Picking #{dataUpdated.id_pallet_stock_history}</div>
                <div className="table-responsive">
                    <table className="table table-sm table-hover table-striped">
                        <thead>
                            <tr>
                                <th>Clave</th>
                                <th>Nombre</th>
                                <th style={{ width: 280 }}>Stock Inicial</th>
                                <th style={{ width: 280 }}>Movimiento</th>
                                <th style={{ width: 280 }}>Cantidad</th>
                                <th style={{ width: 280 }}>Saldo</th>
                            </tr>
                        </thead>
                        <tbody>
                            {React.Children.toArray(dataUpdated.data.map((p, i) => {
                                return <tr>
                                    <td>{p.key_product}</td>
                                    <td>{p.name_product}</td>
                                    <td className="text-center">{p.qty_real}</td>
                                    <td className="text-center">{p.movement}</td>
                                    <td className="text-center">{p.qty_product}</td>
                                    <td className="text-center">{p.saldo}</td>
                                </tr>
                            }))}
                        </tbody>
                    </table>
                </div>
            </>}

        </> : ''}

        {parseInt(historyFull) === 1 ? <>
            <div className="mt-4 mb-2 font-weight-bold"><span>Historial De Pickings</span></div>
            <div className="table-responsive">
                <table className="table table-sm table-hover table-striped">
                    <thead>
                        <tr>
                            <th>Clave</th>
                            <th>Nombre</th>
                            <th style={{ width: 280 }}>Stock Inicial</th>
                            <th style={{ width: 280 }}>Movimiento</th>
                            <th style={{ width: 280 }}>Cantidad</th>
                            <th style={{ width: 280 }}>Saldo</th>
                        </tr>
                    </thead>
                    <tbody>
                        {React.Children.toArray(rows.map((p, i) => {
                            return <tr>
                                <td>{p.key_product}</td>
                                <td>{p.name_product}</td>
                                <td className="text-center">{p.qty_real}</td>
                                <td className="text-center">{p.movement}</td>
                                <td className="text-center">{p.qty_product}</td>
                                <td className="text-center">{p.saldo}</td>
                            </tr>
                        }))}
                    </tbody>
                </table>
            </div>

        </> : ''}
    </ReactPlaceholder>
}

PalletStockForm.defaultProps = {
    data: {
        id_pallet_stock: '',
        name_pallet_stock: '',
        id_branch_office: ''
    },
    onSubmit: () => { },
    loadSubmit: false
}

export default PalletStockForm;